import { SocialShareModalProps } from '@prezi/viewer-common';
import { DesignProject } from '../../models/DesignProject';
import { i18n } from '../../i18n';
import { glassboxWebPrezigram } from '@prezi/client-logger-module';

export const extractSocialShareModalProps = (presentationMetadata: DesignProject): SocialShareModalProps => {
    return {
        oid: presentationMetadata.oid,
        title: presentationMetadata.title,
        tags: [],
        logCopyShareLink: () => {
            glassboxWebPrezigram.logCopyPublishLink({ prezi_oid: presentationMetadata.oid });
        },
        logSocialShare: network => {
            glassboxWebPrezigram.logSharePublish({
                prezi_oid: presentationMetadata.oid,
                share_type: network,
            });
        },
        text: {
            modalTitle: i18n._('Share Design'),
            linkSubheading: i18n._('Link'),
            copiedTooltip: i18n._('Copied'),
            copyButtonDefault: i18n._('Copy'),
            copyButtonSuccess: i18n._('Copied'),
            tooltipFacebook: i18n._('Facebook'),
            tooltipLinkedIn: i18n._('LinkedIn'),
            tooltipTwitter: i18n._('Twitter'),
            tooltipGoogleClassroom: i18n._('Google Classroom'),
        },
    };
};
